import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/1brex7h8_Logo%20b%C3%A6otlagt.png"
                alt="NeonSign - LED Technology & Signs"
                className="h-12 w-auto"
              />
            </Link>
            <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-sm">
              Skiltning og wayfinding til komplekse projekter. Vi forener kreativitet med struktur – fra idé og design til produktion og montering.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h3 className="text-xs font-medium uppercase tracking-[0.15em] text-white/40 mb-6">
              Navigation
            </h3>
            <nav className="flex flex-col gap-4">
              {[
                { name: 'Forside', path: '/' },
                { name: 'Løsninger', path: '/loesninger' },
                { name: 'Cases', path: '/cases' },
                { name: 'Om os', path: '/om-os' },
                { name: 'Kontakt', path: '/kontakt' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-nav-${link.path.replace('/', '') || 'home'}`}
                  className="text-white/60 hover:text-white transition-colors duration-300 text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Solutions */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-medium uppercase tracking-[0.15em] text-white/40 mb-6">
              Løsninger
            </h3>
            <nav className="flex flex-col gap-4">
              <Link
                to="/loesninger"
                className="text-white/60 hover:text-white transition-colors duration-300 text-sm"
              >
                Se vores løsninger her
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-medium uppercase tracking-[0.15em] text-white/40 mb-6">
              Kontakt
            </h3>
            <div className="flex flex-col gap-4 text-sm">
              <a 
                href="tel:+4536308080" 
                data-testid="footer-phone"
                className="text-white/60 hover:text-white transition-colors duration-300"
              >
                +45 36 30 80 80
              </a>
              <a 
                href="mailto:neonsign@neonsign.dk" 
                data-testid="footer-email"
                className="text-white/60 hover:text-white transition-colors duration-300"
              >
                neonsign@neonsign.dk
              </a>
              <address className="text-white/60 not-italic">
                Symfonivej 35<br />
                2730 Herlev
              </address>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs tracking-wide">
            © {currentYear} NeonSign. Siden 1994.
          </p>
          <div className="flex items-center gap-6">
            <a href="/privatlivspolitik" className="text-white/40 hover:text-white/60 text-xs transition-colors duration-300">
              Privatlivspolitik
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
